export enum DeviceTypeEnum {
  CLASS = 'CLASS',
  DEVICE = 'DEVICE'
}



// WEBPACK FOOTER //
// ./src/app/enums/devices.enum.ts